module.exports = __webpack_public_path__ + "js/4.71196674.worker.js"